import React from "react";
import NHBCLogo from "../../Content/Images/NHBCLogo.png";
import PremierGuaranteeLogo from "../../Content/Images/PremierGuaranteeLogo.svg";
import ICWLogo from "../../Content/Images/ICWLogo.svg";
import LABCWarrantyLogo from "../../Content/Images/LABCWarrantyLogo.png";
import QAssureLogo from "../../Content/Images/QAssureLogo.png";
import GlobalLogo from "../../Content/Images/GlobalLogo.png";
import BuildZoneLogo from "../../Content/Images/BuildZoneLogo.png";

interface Props {
    className?: string;
    providerName: string;
}

export const WarrantyLogo = (props: Props) => {
    const getWarrantyLogo = () => {
        const name = props.providerName.toLowerCase();

        if (name.includes("icw")) {
            return { src: ICWLogo, alt: "ICW Logo" };
        }
        if (name.includes("q assure")) {
            return { src: QAssureLogo, alt: "Q Assure Logo" };
        }
        if (name.includes("labc")) {
            return { src: LABCWarrantyLogo, alt: "LABC Warranty Logo" };
        }
        if (name.includes("global")) {
            return { src: GlobalLogo, alt: "Global Home Warranties Logo" };
        }
        if (name.includes("premier")) {
            return { src: PremierGuaranteeLogo, alt: "Premier Guarantee Logo" };
        }
        if (name.includes("nhbc")) {
            return { src: NHBCLogo, alt: "NHBC Logo" };
        }
        if (name.includes("build")) {
            return { src: BuildZoneLogo, alt: "Build-Zone" };
        }
        return { src: NHBCLogo, alt: "Default Warranty Logo" };
    };

    const logoDetails = getWarrantyLogo();

    return (
        <img
            src={logoDetails.src}
            alt={logoDetails.alt}
            className={props.className}
            style={{
                background: props.providerName.toLowerCase().includes("global") ? "#1b1b1d" : props.providerName.toLowerCase().includes("q assure") ? "#124395" : "",
                height: props.providerName.toLowerCase().includes("q assure") ? "136px" : "",
            }}
        />
    );
};
